/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BrokerageItemResource { 
    id: number;
    title: string;
    value: number;
    type: string;
    image: string;
}

